export enum ClaimAccessType {
	ARTIST = 'Artist',
	MANAGER = 'Manager',
	LABEL = 'Label',
	PROVIDER = 'Provider',
}

export enum ClaimScreen {
	SELECT_CLAIM_TYPE = 'select_claim_type',
	NEW_ARTIST = 'new_artist',
	ARTIST_SOCIALS = 'artist_socials',
	ARTIST_DISCOGRAPHY_LIVE = 'artist_discography_live',
	ARTIST_DISCOGRAPHY_TAKEDOWN = 'artist_discography_takedown',
	NEW_PROVIDER = 'new_provider',
	MANAGER_ARTIST_LIST = 'manager_artist_list',
	MANAGER_ADD_ARTIST = 'manager_add_artist',
	MANAGER_EDIT_ARTIST = 'manager_edit_artist',
	LABEL_LIST = 'label_list',
	LABEL_ADD = 'label_add',
	LABEL_EDIT = 'label_edit',
}

export type ArtistFormData = {
	artistUpc: string;
	facebook: string;
	instagram: string;
	twitter: string;
	website: string;
	displayName?: string;
	artist?: {
		id: number;
		name: string;
		picture: string;
	};
};

export type ProviderFormData = {
	providerUpc1: string;
	providerUpc2: string;
	provider?: {
		id: number;
		name: string;
	};
};

export type LabelFormData = {
	labelSubLabels: SubLabel[];
};

export type SubLabel = {
	id: number;
	name: string;
	upc: string;
	providerId: number;
	providerName: string;
};

export type ManagerArtist = {
	id: number;
	name: string;
	picture: string;
	upc: string;
	instagram?: string;
	facebook?: string;
	twitter?: string;
	website?: string;
};

export type ManagerFormData = {
	managerArtists: ManagerArtist[];
};

export type FormFieldChange<Type extends ClaimFormData> = <
	T extends keyof Type,
>(
	key: T,
	value: Type[T],
) => void;

export type ClaimFormData =
	ArtistFormData | ProviderFormData | LabelFormData | ManagerFormData;
